<atlas-sidebar>
  <div nav-header class="business-navbar__sidebar__header">
    <ng-container *ngIf="!(businessAppBranding$ | async)">
      <div *ngIf="!!(coBrandingUrl$ | async)" class="business-navbar__sidebar_powered-by">
        <span class="business-navbar__sidebar_powered-by__text">{{ 'COMMON.POWERED_BY' | translate }} </span>
        <img class="business-navbar__sidebar_powered-by__logo" [src]="coBrandingUrl$ | async"/>
      </div>
      <div class="business-navbar__sidebar__header__logo" [ngStyle]="{'max-height.px': logoHeight$ | async}">
        <img #logo *ngIf="!!(logoUrl$ | async)" [src]="logoUrl$ | async" (load)="logoLoaded(logo)" class="business-navbar__sidebar__header__logo__img" />
      </div>
    </ng-container>
    <div class="business-navbar__sidebar__header__center"
      [ngClass]="{
        'business-navbar__sidebar__header__center--multi-location': isBrandType$ | async,
        'business-navbar__sidebar__header__center__no-logo': businessAppBranding$ | async
      }">
      <div *ngIf="isBrandType$ | async" class="business-navbar__sidebar__header__center__multi-location">Multi-Location
      </div>
      <div class="business-navbar__sidebar__header__center__center-name">{{ businessCenterName$ | async }}</div>
    </div>
  </div>
  <div nav-items class="business-navbar__sidebar__items">
    <atlas-bc-nav-item class="business-navbar__primary-item" *ngFor="let item of (topBusinessNavigationItems$ | async)" [sideNavigationItem]="item"></atlas-bc-nav-item>
    <div *ngIf="(productBusinessNavigationItems$ | async).length > 0 || (storeBusinessNavigationItems$ | async).length > 0">
      <div class="business-navbar__sidebar_my-business-title">
        {{ 'NAVIGATION.PINNED_PRODUCTS' | translate:'Products' }}
      </div>
    </div>
    <atlas-bc-pinned-items class="business-navbar__primary-item" [sideNavigationItem]="productBusinessNavigationItems$"></atlas-bc-pinned-items>
    <atlas-bc-nav-item class="business-navbar__primary-item" *ngFor="let item of (storeBusinessNavigationItems$ | async)" [sideNavigationItem]="item"></atlas-bc-nav-item>
    <div *ngIf="(bottomBusinessNavigationItems$ | async).length > 0">
      <div class="business-navbar__sidebar_my-business-title">
        {{ 'NAVIGATION.MY_BUSINESS' | translate:'My Business' }}
      </div>
    </div>
    <div #injectionSpace></div>
    <atlas-bc-nav-item class="business-navbar__primary-item" *ngFor="let item of (bottomBusinessNavigationItems$ | async)" [sideNavigationItem]="item"></atlas-bc-nav-item>
  </div>
  <div nav-footer class="business-navbar__sidebar__footer_main">
    <div class="business-navbar__sidebar__footer" (click)="openAssistanceModal()">
      <span class="business-navbar__sidebar__footer__picture">
        <img [src]="(salespersonPictureUrl$ | async)" />
      </span>
      <span class="business-navbar__sidebar__footer__contact">
        <div class="business-navbar__sidebar__footer__contact__name" *ngIf="marketName$ | async">{{ marketName$ | async }}</div>
        <div class="business-navbar__sidebar__footer__contact__name" *ngIf="!(marketName$ | async)">{{ partnerName$ | async }}</div>
        <div class="business-navbar__sidebar__footer__contact__message">
          <span><i class="material-icons business-navbar__sidebar__footer__contact__message__icon">chat_bubble</i></span>
          <span class="business-navbar__sidebar__footer__contact__message__text">{{ contactMessage$ | async }}</span>
        </div>
      </span>
    </div>
    <ng-container *ngIf="businessAppBranding$ | async">
      <ng-container *ngIf="!!(logoUrl$ | async)">
        <div class="business-navbar__sidebar__footer__logo__border"></div>
        <ng-container *ngIf="!(coBrandingUrl$ | async)">
          <div class="business-navbar__sidebar__footer__logo__wide">
            <span class="business-navbar__sidebar__footer__powered-by">{{ 'COMMON.POWERED_BY' | translate }} </span>
            <img #logo [src]="logoUrl$ | async" (load)="logoLoaded(logo)" class="business-navbar__sidebar__footer__logo__img__wide" />
          </div>
        </ng-container>
        <ng-container *ngIf="!!(coBrandingUrl$ | async)">
          <div class="business-navbar__sidebar__footer__logo__narrow">
            <img #logo [src]="logoUrl$ | async" (load)="logoLoaded(logo)" class="business-navbar__sidebar__footer__logo__img__narrow" />
            <div class="business-navbar__sidebar__footer__powered-by__container">
              <span class="business-navbar__sidebar_powered-by__text">{{ 'COMMON.POWERED_BY' | translate }} </span>
              <img class="business-navbar__sidebar_powered-by__logo" [src]="coBrandingUrl$ | async"/>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <div *ngIf="showCancellationModal$ | async" class="business-navbar__sidebar__footer__change-subscription" (click)="openChangeSubscriptionModal()">
      {{ 'REQUEST_SUBSCRIPTION_CHANGE.CHANGE_SUBSCRIPTION' | translate }}
    </div>
  </div>
</atlas-sidebar>
